"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/Recipients/EditRecipientDialog.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);





var _broadcast = require('shared/enum/broadcast');
var _peers = require('shared/selectors/peers');
var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _actions3 = require('web/actions'); var _actions4 = _interopRequireDefault(_actions3);
var _hooks = require('web/services/hooks');
var _noticeBar = require('web/services/context/noticeBar');
var _helpers = require('web/screens/Broadcast/Wizard/helpers');

var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _Form = require('web/components/Form');
var _Spinner = require('web/components/Spinner');
var _Patient = require('web/screens/Directory/Forms/Patient'); var _Patient2 = _interopRequireDefault(_Patient);
var _noAutofill = require('web/screens/Broadcast/Wizard/Recipients/noAutofill');










// Their message has gone (or is going) out with the values it had.
const isSent = (status) => status === _broadcast.broadcastMsgStatus.COMPLETED
  || status === _broadcast.broadcastMsgStatus.FAILED || status === _broadcast.broadcastMsgStatus.PROCESSING
  // Written to the chat already; only its text waits for consent.
  || status === _broadcast.broadcastMsgStatus.AWAITING_CONSENT

/* This campaign's values for the recipient: editable until their message
 * goes out. A blank clears their own value, so the variable's default
 * applies. */
const CampaignValues




 = ({ campaign, row, columns, onSaved }) => {
  const id = _react.useId.call(void 0, )
  const [values, setValues] = _react.useState(() =>
    Object.fromEntries(columns.map(c => [c.name, _nullishCoalesce(row.Values[c.name], () => ( ''))])))
  const [isSaving, setIsSaving] = _react.useState.call(void 0, false)
  const [error, setError] = _react.useState(null)
  const isLocked = isSent(row.Status)
  const key = _optionalChain([row, 'access', _ => _.Patient, 'optionalAccess', _2 => _2.PatientKey]) 

  const save = () => {
    setIsSaving(true)
    setError(null)
    _actions2.default.updateCampaignRecipientValues({ CampaignKey: campaign.CampaignKey, PatientKey: key, Values: values })
      .then(onSaved)
      .catch((e) => {
        setError(_helpers.errorText.call(void 0, e, "Couldn't save the values"))
        setIsSaving(false)
      })
  }

  if (!columns.length) return null
  return (
    _react2.default.createElement('fieldset', { className: "recipients-edit--values", 'aria-labelledby': `${id}-title`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 66}}
      , _react2.default.createElement('legend', { id: `${id}-title`, className: "recipients-edit--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 67}}, "This campaign's values"  )
      ,  isLocked && (
        _react2.default.createElement('p', { className: "recipients-edit--note", __self: this, __source: {fileName: _jsxFileName, lineNumber: 69}}, "Their message has gone out, so these values can't change."         )
      )
      , _react2.default.createElement('div', { className: "recipients-edit--grid", __self: this, __source: {fileName: _jsxFileName, lineNumber: 71}}
        ,  columns.map(c => (
          _react2.default.createElement('label', { key: c.name, className: "recipients-edit--field", __self: this, __source: {fileName: _jsxFileName, lineNumber: 73}}
            , _react2.default.createElement('span', { className: "recipients-edit--name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 74}},  c.name )
            , _react2.default.createElement('input', {
              className: "blm-text-input recipients-edit--input" ,
              'aria-label': c.name,
              placeholder: _nullishCoalesce(c.fallback, () => ( '')),
              readOnly: isLocked,
              ..._noAutofill.NO_AUTOFILL,
              value: _nullishCoalesce(values[c.name], () => ( '')),
              onChange: e => setValues(v => ({ ...v, [c.name]: e.target.value })), __self: this, __source: {fileName: _jsxFileName, lineNumber: 75}}
            )
          )
        ))
      )
      ,  error && _react2.default.createElement('p', { role: "alert", className: "broadcast-wizard--error", __self: this, __source: {fileName: _jsxFileName, lineNumber: 87}},  error ) 
      ,  !isLocked && (
        _react2.default.createElement('div', { className: "recipients-edit--foot", __self: this, __source: {fileName: _jsxFileName, lineNumber: 89}}
          , _react2.default.createElement(_Form.Button, { isLoading: isSaving, onClick: save, __self: this, __source: {fileName: _jsxFileName, lineNumber: 90}}, "Save values" )
        )
      )
    )
  )
}

/* Rev 32 V3: a recipient's pencil opens their directory details (the
 * Directory's own patient form, saved as the patient page saves it) and this
 * campaign's values for them. */
const EditRecipientDialog = ({ campaign, row, columns, onClose }) => {
  const patientKey = (_nullishCoalesce(_optionalChain([row, 'optionalAccess', _3 => _3.Patient, 'optionalAccess', _4 => _4.PatientKey]), () => ( null))) 
  const patient = _hooks.useAppSelector.call(void 0, state => patientKey ? _peers.selectPatientByKey.call(void 0, state, patientKey) : null)
  const [hasFailed, setHasFailed] = _react.useState.call(void 0, false)
  // Review R800-17: the form edits the record the server has now, so it
  // waits for this opening's read.
  const [isLoaded, setIsLoaded] = _react.useState.call(void 0, false)
  // Review R800-18: a save from an earlier opening doesn't close this one.
  const opening = _react.useRef.call(void 0, 0)
  const { showWarningBar, showSuccessBar } = _noticeBar.useNoticeBar.call(void 0, )

  _react.useEffect.call(void 0, 
    () => {
      opening.current += 1
      setIsLoaded(false)
      setHasFailed(false)
      if (!patientKey) return
      let isCurrent = true
      _actions4.default.getPatient({ PatientKey: patientKey }).then(
        () => { if (isCurrent) setIsLoaded(true) },
        () => { if (isCurrent) setHasFailed(true) },
      )
      return () => { isCurrent = false }
    },
    [patientKey],
  )

  const renderOpening = opening.current
  const onSubmit = (values) => {
    if (!patientKey) return Promise.resolve()
    const savedIn = renderOpening
    return _actions4.default.updatePatient({
      PatientKey: patientKey,
      FirstName: values.firstName,
      LastName: values.lastName,
      DateOfBirth: values.dob,
      Email: values.email,
      Phone: values.phone,
      ForeignID: values.foreignID,
    })
      .then(() => {
        showSuccessBar('Patient information updated')
        if (savedIn === opening.current) onClose()
      })
      .catch(() => showWarningBar('Failed to update patient information'))
  }

  return (
    _react2.default.createElement(_Modal2.default, { isOpen: !!row, title: "Edit patient" , className: "recipients-edit", onClose: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 148}}
      ,  row && patientKey && (
        _react2.default.createElement(CampaignValues, {
          key: `${patientKey}:${opening.current}`,
          campaign: campaign,
          row: row,
          columns: columns,
          onSaved: () => {
            showSuccessBar('Values updated')
            // A save that answers after this dialog moved on to another patient
            // leaves that one open (review R800-68).
            if (renderOpening === opening.current) onClose()
          }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 150}}
        )
      )
      ,  hasFailed
        ? _react2.default.createElement('p', { role: "alert", className: "broadcast-wizard--error", __self: this, __source: {fileName: _jsxFileName, lineNumber: 164}}, "Couldn't load the patient."   )
        : isLoaded && patient && patientKey
          ? (
              _react2.default.createElement(_Patient2.default, {
                key: patientKey,
                patientKey: patientKey,
                submitBtnLabel: "Save details" ,
                onSubmit: onSubmit,
                onCancel: onClose,
                hideOrgNotice: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 167}}
              )
            )
          : _react2.default.createElement(_Spinner.SimpleSpinner, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 176}} )
      
    )
  )
}

exports. default = _react.memo.call(void 0, EditRecipientDialog)
